module.exports = __webpack_public_path__ + "img/book4.b11511e0.png";